import { makeRequest } from "./jwtHelpers";

const getGeoIP = async () => {
  try {
    const response = await makeRequest("get", "/geoip");
    return response.data;
  } catch (error) {
    console.error("Error fetching geoip data:", error);
    return null;
  }
};

export { getGeoIP };
